/**
 * EVM Window Injected Extension
 *
 * Provides support for wallets that are injected into window.ethereum rather than
 * announcing via EIP-6963. This is primarily needed for **wallet app in-app
 * browsers** (e.g., MetaMask mobile browser, Trust Wallet browser, Coinbase
 * Wallet browser).
 *
 * @example
 * ```typescript
 * import { addEIP6963Extension } from '@dynamic-labs-sdk/evm/eip6963';
 * import { addEvmWindowInjectedExtension } from '@dynamic-labs-sdk/evm/window-injected';
 *
 * // Add both extensions - EIP-6963 takes priority, window injected is fallback
 * addEIP6963Extension(client);
 * addEvmWindowInjectedExtension(client);
 * ```
 */
import { assertPackageVersion } from '@dynamic-labs-sdk/assert-package-version';

import {
  name as packageName,
  version as packageVersion,
} from '../../package.json';
assertPackageVersion(packageName, packageVersion);

export { addEvmWindowInjectedExtension } from '../windowInjected/addEvmWindowInjectedExtension';
